// src/services/bankAccountService.js
//
// Wraps /api/bank-accounts/* backend calls.

import { api } from './api';

export const bankAccountService = {
  getAccounts: () =>
    api.get('/api/bank-accounts/'),

  getSummary: () =>
    api.get('/api/bank-accounts/summary'),

  getCashAccount: () =>
    api.get('/api/bank-accounts/cash'),

  getAccount: (accountId) =>
    api.get('/api/bank-accounts/' + accountId),

  createAccount: (data) =>
    api.post('/api/bank-accounts/', data),

  updateAccount: (accountId, data) =>
    api.put('/api/bank-accounts/' + accountId, data),

  getTransactions: (accountId) =>
    api.get('/api/bank-accounts/' + accountId + '/transactions'),

  deposit: (accountId, data) =>
    api.post('/api/bank-accounts/' + accountId + '/deposit', data),

  withdraw: (accountId, data) =>
    api.post('/api/bank-accounts/' + accountId + '/withdraw', data),

  updateTransaction: (accountId, transactionId, data) =>
    api.put('/api/bank-accounts/' + accountId + '/transactions/' + transactionId, data),

  deleteTransaction: (accountId, transactionId) =>
    api.delete('/api/bank-accounts/' + accountId + '/transactions/' + transactionId),
};